/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PriceDto } from './PriceDto';
import type { TariffDto } from './TariffDto';
export type PriceTableDto = {
    /**
     * Price table identifier. Type: 'UUID'
     */
    id: string;
    /**
     * Price table payment type.
     */
    paymentType: PriceTableDto.paymentType;
    /**
     * Price table ticket format.
     */
    ticketFormat: PriceTableDto.ticketFormat;
    /**
     * Price table periodic DOW validity.
     */
    periodicDowValidity: string;
    /**
     * Price table tariff.
     */
    tariff?: TariffDto;
    /**
     * Prices.
     */
    prices?: Array<PriceDto>;
    /**
     * Date from which the entity is valid.
     */
    validFrom: string;
};
export namespace PriceTableDto {
    /**
     * Price table payment type.
     */
    export enum paymentType {
        CASH = 'CASH',
        EMV = 'EMV',
    }
    /**
     * Price table ticket format.
     */
    export enum ticketFormat {
        IDENTIFIER = 'IDENTIFIER',
        MOBILE = 'MOBILE',
        QR = 'QR',
        PAPER = 'PAPER',
    }
}

